import axios from "services/axiosB2C";

async function RequestToken() {
  try {
    const { data } = await axios.post(
      "/oauthtokens/request-token",
      {},
      {
        headers: {
          Authorization: `Basic ${process.env.REACT_APP_B2C_TOKEN}`,
        },
      }
    );
    if (data && data.token) return data.token;

    throw new Error("Token not found");
  } catch (e) {
    throw e;
  }
}

export { RequestToken };



// WEBPACK FOOTER //
// src/services/b2c.js